import { keyframes } from "@busbud/design-system-components/dist/styles/keyframes";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme.busbud;
  return {
    dialog: {
      borderRadius: spacing(3)
    },
    content: {
      position: "relative",
      padding: spacing(4.5, 3, 0, 2)
    },
    footer: {
      display: "flex",
      justifyContent: "center",
      padding: spacing(3, 0)
    },
    title: {
      padding: spacing(0, 2)
    }
  };
});

const myKeyframe = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, 16px, 0);
  }

  100% {
    opacity: 1;
  }
`;

export const useAnimation = createStyles(() => {
  return {
    changeView: {
      animation: myKeyframe
    },
    container: {
      animation: `${myKeyframe} 0.3s ease-in-out .15s backwards`
    }
  };
});
